
import React, { ReactElement } from 'react';
import { Navigate } from 'react-router-dom';

export type ProtectedRouteProps = {
  authenticationPath: string;
  outlet: ReactElement;
};

export default function ProtectedRoute({
  authenticationPath,
  outlet,
}: ProtectedRouteProps) {
  const isAuthenticated = true; 
const appUsedFor = process.env.REACT_APP_USED_FOR;
  return isAuthenticated ? outlet : <Navigate to={authenticationPath} />;
}
